import {useSuspenseQuery} from "@tanstack/react-query";
import {BreederService} from "../services/breeder-service";

export const useBreederInfo = () => useSuspenseQuery({
    queryKey: ['breeder', 'info'],
    queryFn: async () => await BreederService.info(),
});

export const useOwnBreederDetails = () => {
    const queryInfo = useSuspenseQuery({
        queryKey: ['breeder', 'self'],
        queryFn: async () => await BreederService.ownDetails(),
    });

    return {
        ...queryInfo,
        get ownDetails() { return queryInfo.data; },
    };
};
